var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-start align-center mt-1"},[_c('BaseActionsButton',{attrs:{"id":"viewDetailsVehicle","iconName":"mdi-eye","iconColor":"primary","customClass":"mr-2","tooltipMessage":"View Details"},on:{"click":function($event){return _vm.viewDetails()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }